// extracted by mini-css-extract-plugin
module.exports = {"personName":"NameAndPosition-module__personName___3GjRP","personPosition":"NameAndPosition-module__personPosition___26v-1"};